export default __webpack_public_path__ + "e6f982f37873046dc623ca2aa479a078.png";